import React from 'react';
import { Users, MessageSquare } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

const itemClass = (active) =>
  `p-3 rounded-lg cursor-pointer transition-all ${active ? 'bg-yellow-400/20 border border-yellow-400' : 'bg-gray-800 hover:bg-gray-700 border border-transparent'}`;

const PanelCard = ({ icon: Icon, title, description, contentClass, children }) => (
  <Card className="bg-gray-900 border-gray-800">
    <CardHeader>
      <CardTitle className="text-white flex items-center">
        <Icon className="w-5 h-5 mr-2 text-yellow-400" />
        {title}
      </CardTitle>
      <CardDescription className="text-gray-500">{description}</CardDescription>
    </CardHeader>
    <CardContent className={contentClass}>{children}</CardContent>
  </Card>
);

export const LeadsList = ({ leads, selectedId, onSelect }) => (
  <PanelCard icon={Users} title="Recent Leads" description="Click to select a customer" contentClass="max-h-64 overflow-y-auto space-y-2">
    {leads.length === 0 && <p className="text-gray-500 text-sm" data-testid="leads-empty">No leads yet</p>}
    {leads.slice(0, 10).map((lead) => (
      <div key={lead.id} onClick={() => onSelect(lead)} className={itemClass(selectedId === lead.id)} data-testid={`lead-item-${lead.id}`}>
        <p className="font-medium text-white">{lead.name}</p>
        <p className="text-sm text-gray-400">{lead.phone}</p>
        <p className="text-xs text-cyan-400">{lead.service}</p>
      </div>
    ))}
  </PanelCard>
);

export const TemplateList = ({ templates, selectedId, onSelect }) => (
  <PanelCard icon={MessageSquare} title="Message Templates" description="Pre-written professional messages" contentClass="space-y-2 max-h-80 overflow-y-auto">
    {Object.entries(templates).map(([id, template]) => (
      <div key={id} onClick={() => onSelect(id)} className={itemClass(selectedId === id)} data-testid={`template-item-${id}`}>
        <p className="font-medium text-white text-sm">{template.name}</p>
        <p className="text-xs text-gray-500 mt-1">{template.description}</p>
      </div>
    ))}
  </PanelCard>
);
